// 左サイドバー（v-navigation-drawer）がハンバーガー（temporary）に切り替わる画面幅(px)。
//
// iPad 横向き（最大は 12.9 インチ Pro の 1366px）までをハンバーガーにしたいので 1400 とする。
// 1440px 以上（多くのノートPC）ではサイドバーを常時表示する。
//
// 注: Vuetify グローバルの mobileBreakpoint は変更しない。グローバルを上げると
//     v-data-table などのモバイル（縦積み）表示にも波及するため、サイドバー専用の
//     閾値として、各レイアウトのドロワー mobile-breakpoint と
//     $vuetify.breakpoint.width 判定でのみ使う。
export const SIDEBAR_MOBILE_BREAKPOINT = 1400
